import { Swal, Toast } from '../plugins/toast.js';
import axios from 'axios';

const cheerio = require('cheerio');

let popup = {
    open(event,url = null,selector = null, removeLastChild = false,childrenToRemove = []){
        event.preventDefault();
        if(!url){
            url = '/tos.txt';
        }
        axios.get(url).then(response => {
            let html = response.data;
            if(selector){
                let resultHtml = cheerio.load(html,null,false);
                let elem = resultHtml(selector);
                let children = elem.children();
                console.log('children:',children);
//                console.log('firstChild:',elem.firstChild);
                //sorting the removeChildren Array
                childrenToRemove.sort(function(a,b){ return a - b; });
                console.log('childrenToRemove:',childrenToRemove);
                for (var i = childrenToRemove.length -1; i >= 0; i--){
                    children.splice(childrenToRemove[i],1);
                }
//                console.log('children2:',children);
                if(removeLastChild){
                    children = children.slice(0,-1);
                }
//                console.log('children2:',children);
                elem.empty();
                elem.append(children);
//                console.log('elem.children:',elem.children());
//                console.log('elem.children:',elem.children);
                html = elem.html();
//                console.log('html after',html);
            }
            Swal.fire({
                html: html,
                showCancelButton: false,
                showConfirmButton: true,
                customClass: 'tos-popup',
                width: '100%',
                customClass: 'tos-popup'
            });
        });

//        console.log(event);
    }
};

export default popup